import { Injectable, inject } from '@angular/core';
import { StorageV2Service } from '@schenck/rotec-components';
import { ReportTemplate } from 'src/dto/report-template';

@Injectable({
  providedIn: 'root',
})
export class ReportTemplateCacheService {
  private readonly storageService = inject(StorageV2Service);

  private readonly Key = 'CurrentReportTemplate';

  save(reportTemplate: ReportTemplate): void {
    this.storageService.setItem(this.Key, reportTemplate || null, JSON.stringify);
  }

  load(): ReportTemplate {
    return this.storageService.getItem(this.Key, JSON.parse) as ReportTemplate;
  }

  remove(): void {
    return this.storageService.setItem(this.Key, null, JSON.stringify);
  }
}
